import moment from 'moment'

const _3hours = 3 * 3600 * 1000

const shift3hoursDatetime = (datetime: any) => new Date(datetime ? +moment(datetime).toDate() - _3hours : datetime).toISOString()

export { shift3hoursDatetime }